<!-- BACKGROUND-IMAGE -->
<div class="login-img">
  <!-- PAGE -->
  <div class="page">
    <div class="">
      <!-- Theme-Layout -->

      <!-- CONTAINER OPEN -->
      <div class="col col-login mx-auto mt-7">
        <div class="text-center">
          <a routerLink="/dashboard/home"
            ><img
              src="./assets/images/brand/logo.svg"
              class="header-brand-img m-0"
              alt=""
          /></a>
        </div>
      </div>
      <div class="container-login100">
        <div class="wrap-login100 p-6">
          <form class="login100-form validate-form">
            <span class="login100-form-title"> Registration </span>
            <div
              class="wrap-input100 validate-input input-group"
              data-bs-validate="Valid email is required: ex@abc.xyz"
            >
              <a
                href="javascript:void(0)"
                class="input-group-text bg-white text-muted"
              >
                <i class="mdi mdi-email" aria-hidden="true"></i>
              </a>
              <input
                class="border-start-0 ms-0 form-control"
                type="email"
                name="email"
                #userEmail
                required
                placeholder="Enter email Id"
              />
            </div>
            <div
              class="wrap-input100 validate-input input-group"
              id="Password-toggle"
            >
              <a
                href="javascript:void(0)"
                class="input-group-text bg-white text-muted"
              >
                <i class="mdi mdi-eye" aria-hidden="true"></i>
              </a>
              <input
                class="border-start-0 ms-0 form-control"
                name="password"
                type="password"
                #userPwd
                required
                placeholder="Enter Password"
              />
            </div>

            <div class="form-group">
              <p *ngIf="errorMessage.length > 0" class="text-danger">
                {{ errorMessage }}
              </p>

              <p *ngIf="error.message.length > 0" class="text-danger">
                {{ error.message }}
              </p>

              <p *ngIf="message.length > 0" class="text-info">
                {{ message }}
              </p>
            </div>
            <label class="custom-control custom-checkbox mt-4">
              <input type="checkbox" class="custom-control-input" />
              <span class="custom-control-label"
                >Agree the
                <a routerLink="/pages/faqs">terms and policy</a></span
              >
            </label>
            <div class="container-login100-form-btn">
              <!-- <button class="btn btn-primary btn-block" (click)="authService.SignUp(userEmail.value, userPwd.value)" >
                                  Register
                              </button> -->
            </div>
            <div class="text-center pt-3">
              <p class="text-dark mb-5">
                Already have account?<a
                  routerLink="/auth/login"
                  class="text-primary ms-1"
                  >Sign In</a
                >
              </p>
            </div>

            <div class="social-icons">
              <ul>
                <li>
                  <a class="btn btn-social btn-block"
                    ><i class="fa fa-google-plus text-google-plus"></i> Sign up
                    with Google</a
                  >
                </li>
                <li>
                  <a class="btn btn-social btn-block mt-2"
                    ><i class="fa fa-facebook text-facebook"></i> Sign in with
                    Facebook</a
                  >
                </li>
              </ul>
            </div>
          </form>
        </div>
      </div>
      <!-- CONTAINER CLOSED -->
      <ng-template ngbNavContent>
        <form (ngSubmit)="Submit()">
          <div class="text-center title-style mb-6">
            <h1 class="mb-2">Login</h1>
            <hr />
            <p class="text-muted">Sign In to your account</p>
          </div>

          <div class="input-group mb-3">
            <a
              href="javascript:void(0)"
              class="input-group-text bg-white text-muted"
            >
              <i class="mdi mdi-email text-muted" aria-hidden="true"></i>
            </a>
            <input
              type="text"
              class="input100 border-start-0 form-control ms-0"
              placeholder="Username"
              autocomplete
              formControlName="username"
            />
          </div>
          <div class="input-group mb-4">
            <a
              href="javascript:void(0)"
              class="input-group-text bg-white text-muted"
            >
              <i class="mdi mdi-eye text-muted" aria-hidden="true"></i>
            </a>
            <input
              type="password"
              class="input100 border-start-0 form-control ms-0"
              placeholder="Password"
              autocomplete
              formControlName="password"
            />
          </div>
          {{ error }}
          <div class="row">
            <div class="col-12">
              <button
                [disabled]="!registrationForm.valid"
                type="submit"
                class="btn btn-lg btn-primary btn-block {{ disabled }}"
              >
                Login
              </button>
            </div>
            <div class="col-12">
              <a
                routerLink="/custom-pages/forget-password/forget-password01"
                class="btn btn-link box-shadow-0 px-0"
                >Forgot password?</a
              >
            </div>
          </div>
          <div class="text-center pt-3">
            <p class="text-dark mb-0">
              Not a member?<a
                routerLink="/auth/register"
                class="text-primary ms-1"
                >Sign UP</a
              >
            </p>
          </div>
          <label class="login-social-icon"
            ><span>Login with Social</span></label
          >
          <div class="d-flex justify-content-center">
            <a href="https://www.google.com/gmail/">
              <div class="social-login me-4 text-center">
                <i class="fa fa-google"></i>
              </div>
            </a>
            <a href="https://www.facebook.com/">
              <div class="social-login me-4 text-center">
                <i class="fa fa-facebook"></i>
              </div>
            </a>
            <a href="https://twitter.com/">
              <div class="social-login text-center">
                <i class="fa fa-twitter"></i>
              </div>
            </a>
          </div>
        </form>
      </ng-template>
    </div>
  </div>
  <!-- END PAGE -->
</div>
<!-- BACKGROUND-IMAGE CLOSED -->
